// @todo - is anyone using this file anymore?
require([
    'jquery',
    'services',
    'jquery_cycle',
    'semantic',
    'ch_selectors',
    'ch_ga',
    'ch_header',
    'ch_semantic_wishlist',
    'ch_semantic_responsive'
], function ($) {

    function emailCaptureSubmitHandler (form) {
        $(form).find('input').blur();
        $('body').maskElement('');
        $.ajax({
            type: 'POST',
            url: form.action,
            data: $(form).serialize(),
            xhrFields: {
                withCredentials: true,
            },
            success: function (res) {
                $('body').unmaskElement('');

                if (!res.success && res.error) {
                    new ModalMessage({ message: res.error });
                    return;
                }

                // Send GA Event
                ga(
                    'send',
                    'event',
                    'Email Capture',
                    'Subscribe',
                    $._('funnel').val(),
                    { nonInteraction: false }
                );
                $('form[name=form_CaptureEmail]').each(function (index, form) {
                    $(form).get(0).reset();
                });

                if (CH.showCategoryPreferencesWindow() === false) {
                    CH.thankYouSubmitEmail();
                };
            },
        });
    }

    $(function () {
        var $lazyLoadImages = $('.js-lazy-load');
        if ($lazyLoadImages.length > 0) {
            require(["unveil"], function() {
                $lazyLoadImages.unveil(400, function() {
                    $(this).on('load', function() {
                        $(this)
                            .addClass('lazy-loaded')
                            .siblings('.active.dimmer')
                            .removeClass('active');
                    });
                });
            });
        }

        // Slideshow
        if (typeof $.fn.cycle !== 'undefined') {
            $('#slideshow').cycle({
                slides: 'div.slides',
                //autoHeight: false,
                log: false,
                speed: 1000,
                pauseOnHover: true
            });
        }

        // Homepage Ad
        $('.homepage-ad-button').on('click', function (e) {
            ga(
                'send',
                'event',
                'Homepage Ad',
                'Button Clicked',
                { nonInteraction: false }
            );
        });

        // Landing on homepage from a referral link
        if (CH.referralPromoCode) {
            var ModalWindowReferralFriendActivationObj = new ModalWindowReferralFriendActivation();
            var window = ModalWindowReferralFriendActivationObj.window;
            ModalWindowReferralFriendActivationObj.show({
                onShow: function () {
                    $('#promo-code').html(CH.referralPromoCode);
                },
            });
        }

        //Newsletter email capture
        CH.validate('form_CaptureEmail_homepage', {
            submitHandler: emailCaptureSubmitHandler,
        });
        CH.validate('form_CaptureEmail_homepage_top', {
            submitHandler: emailCaptureSubmitHandler,
        });

        var userIdentityIdString = CH.User && CH.User.identity_id
            ? CH.User.identity_id + ' - '
            : '';
    });
});
